<template>
  <div class="ma-0 pa-0">
    <v-row
      class="pt-0 mt-0"
    >
      <v-col cols="12">
        <candidate-position-matching-form
          ref="candidatePositionMatchingForm"
          :read-only="readOnly"
          :candidate="candidate"
        />
      </v-col>
    </v-row>
  </div>
</template>

<script>
import CandidatePositionMatchingForm from '@/components/candidate/positionMatching/CandidatePositionMatchingForm.vue';

export default {
  components: {
    CandidatePositionMatchingForm,
  },
  props:
    {
      readOnly: {
        type: Boolean,
        default: false,
      },
      candidate: {
        type: Object,
        default: null,
      },
    },
  data: () => ({
    candidateId: null,
  }),
  methods: {
    async submit() {
      const result = {
        success: false,
        completed: false,
      };
      result.completed = await this.validate();
      if (!result.completed) return result;

      this.$bus.$emit('loading', true);

      const res = await this.$refs.candidatePositionMatchingForm.submit();

      if (!res) {
        this.$bus.$emit('showError');
        this.$bus.$emit('loading', false);
        return result;
      }
      this.$bus.$emit('loading', false);
      this.$bus.$emit('showSuccess', 'Successfully updated your Matchmaking preferences.');
      this.$emit('registration-success');
      result.success = true;
      return result;
    },
    async validate() {
      const validateComponentsResult = await Promise.all([
        this.$refs.candidatePositionMatchingForm.validate(),
      ]).then((values) => !values.includes(false));
      return validateComponentsResult;
    },
    resetForm() {
      this.$refs.userInformationForm.reset();
      this.$refs.generalPhoneForm.reset();
    },
  },
};
</script>
